// extracted by mini-css-extract-plugin
module.exports = {"holdings":"Holdings_holdings__MQm8s","holdingsValue":"Holdings_holdingsValue__2smGC"};